<template>
  <div>
    <b-button v-b-modal.modal-sale variant="primary" size="sm" class="float-right no-print absolute-button"><b class="bi bi-plus-square"></b>
      বিক্রয়
    </b-button>
    <b-modal id="modal-sale" size="xl" title="বিক্রয়ের খাতা">
      <b-row>
        <div class="col-lg-6 col-md-12">
          <span>প্রোডাক্ট নির্বাচন করুন:</span>
          <b-form-select v-model="currentProduct" :options="getProductList"></b-form-select>
          <h5 class="mt-2">নির্বাচিত প্রোডাক্ট: <b>{{ selectedProduct.primaryName }}</b></h5>

          <p>স্টকের বিবরণী</p>
          <table class="table table-bordered table-sm">
            <thead>
            <tr>
              <td>গড় ক্রয়মূল্য</td>
              <td>বর্তমান স্টকের পরিমান</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="i in stockInfo" :key="i">
              <td class="bn-number">{{ AmountService.commaDecimalWithCurrency( i.price) }}</td>
              <td class="bn-number">{{ i.qty }}</td>
            </tr>
            <tr>
              <td>মোট স্টক</td>
              <td class="bn-number">{{ stockTotal }}</td>
            </tr>
            </tbody>
          </table>

          <b-form class="mb-3">
            <b-form-checkbox class="mb-2 mr-sm-2 mb-sm-0" v-model="purchaseRateCheckBox">ক্রয়মূল্য পরিবর্তন করুন</b-form-checkbox>
            <b-form-input
                id="inline-form-input-name"
                class="mb-2 mr-sm-2 mb-sm-0 bn-number"
                placeholder="0.00"
                :readonly="!purchaseRateCheckBox"
                v-model="editablePurchaseRate"
            ></b-form-input>
          </b-form>

          <table class="table table-bordered table-sm">
            <thead class="text-right">
            <tr>
              <th scope="col">পরিমান
              </th>
              <th scope="col">বিক্রয় দর
              </th>
              <th scope="col">মোট মূল্য</th>
            </tr>
            </thead>
            <tbody>
            <tr>


              <td><input class="form-control digit-input" type="number" :readonly="previewStatus"
                         v-model="saleQuantity"/></td>
              <td><input class="form-control digit-input" type="number" disabled  v-model="saleRate"/>
              </td>
              <td><input class="form-control digit-input" :readonly="previewStatus" v-model="saleTotal"/></td>
            </tr>
            <tr>
              <td colspan="2" class="text-right">সর্বমোট</td>
              <td class="text-right bn-number">{{ AmountService.commaWithCurrency(saleTotal) }}</td>
            </tr>
            </tbody>
          </table>
          <p>এই বিক্রয় হতে লাভ: <b class="bn-number">{{ AmountService.commaDecimalWithCurrency(getProfit) }}</b>, শতকরা
            লাভের হার <b v-if="editablePurchaseRate!=0" class="bn-number">{{ AmountService.commaDecimalWithCurrency(getProfitMargin) }}</b>
            <b v-else >ক্রয়মূল্য শূণ্য, শতকরা লাভ নির্ণয় অসম্ভব।</b></p>
          </div>
        <div class="col-lg-6 col-md-12">
          <div v-if="previewStatus">
            <h3 class="text-center h3 text-warning font-weight-bold">সতর্কতার সাথে নিশ্চিত করুন</h3>
            <h5 class="text-center h4">প্রোডাক্ট বিক্রয়</h5>
            <table class="table table-bordered table-sm">

              <thead>
              <tr>
                <td colspan="3"><h5>প্রোডাক্টের নাম: <b>{{ confirmedData.info.primaryName }}</b></h5></td>
              </tr>
              <tr class="text-right">
                <th scope="col">পরিমান
                </th>
                <th scope="col">দর
                </th>
                <th scope="col">মোট মূল্য</th>
              </tr>
              </thead>
              <tbody>
              <tr class="text-right">


                <td class="bn-number">{{ AmountService.comma(this.confirmedData.quantity) }}</td>
                <td class="bn-number">{{ AmountService.commaDecimalWithCurrency(this.confirmedData.saleRate) }}</td>
                <td class="bn-number">{{ AmountService.commaDecimalWithCurrency(this.confirmedData.amount) }}</td>
              </tr>
              <tr>
                <td colspan="2" class="text-right">সর্বমোট</td>
                <td class="text-right bn-number">{{ AmountService.commaDecimalWithCurrency(this.confirmedData.amount) }}</td>
              </tr>
              <tr>
                <td colspan="3"><i>কথায়: </i> {{ AmountService.toWordCurrency(this.confirmedData.amount) }}</td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>
      </b-row>
      <b-row>
        <b-col>
          <b-button @click="preview" class="float-right button-abc" variant="primary">চেক করুন</b-button>
        </b-col>
        <b-col>
          <div v-if="previewStatus">
            <b-button @click="correction" variant="danger">সংশোধন করুন</b-button>
            <b-button class="float-right" @click="confirm" variant="success">নিশ্চিত করুন</b-button>
          </div>

        </b-col>
      </b-row>

      <template #modal-footer="{ cancel }">

        <b-button variant="info" @click="reset()">
          <i class="fa fa-undo" aria-hidden="true"></i>
          রিসেট করুন
        </b-button>
        <b-button variant="danger" @click="cancel()">
          <i class="fa fa-times" aria-hidden="true"></i> বন্ধ করুন
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>

import AmountService from "../../services/amountService";

export default {
  name: "SaleModal",
  data() {
    return {
      previewStatus: false,
      weightedPurchaseRate: "",
      saleQuantity: "",
      saleRate: "",
      saleTotal: "",
      profit: 0,
      stockPurchaseStatus: null,
      stockPurchaseWeightedTotalSumArray: [],
      confirmedData: {},
      selectedProduct:{},
      currentProduct: "",
      stockArray: [],
      purchaseRateCheckBox: false,
      editablePurchaseRate:  "ক্রয়মূল্য জানতে সঠিক পরিমান লিখুন",
      stockInfo: [],
      stockLength : 0
    }

  },
  props: {
    productListProp: []
  },
  computed: {
    AmountService() {
      return AmountService
    },
    getProductList(){
      let pList = []
      if(this.productListProp){
        this.productListProp.forEach((x)=>pList.push({value: x.id, text: x.primaryName, id: x.id}))
      }
      return pList
    },
    stockPurchaseAndStatusComputed() {
      return this.stockPurchaseAndStatus()
    },
    getStockWeightedTotalSumComputed() {
      return this.getStockWeightedTotalSum()
    },
    getProfit() {
      return this.calculateProfit()
    },
    getProfitMargin() {
      return this.calculateProfitMargin()
    },
    stockTotal() {
      console.log(this.stockInfo.qtyQueue)
      if(this.stockInfo){
        return this.stockInfo.reduce((sum, x)=> sum+x.qty,0);
      }else{
        return 0;
      }

    }
      // getWeightedAveragePurchaseRate(){
    //   let total_stock = this.stockPurchaseAndStatus().reduce((sum , x)=>x.quantity, 0)
    //   return total_stock
    // }
  },
  methods: {
    preview() {
      this.previewStatus = true;

      this.confirmedData = {
        info: this.selectedProduct,
        purchaseRate: parseFloat(this.editablePurchaseRate), // Need to modify
        quantity: isNaN(parseFloat(this.saleQuantity)) ? 0 : parseFloat(this.saleQuantity),
        saleRate: parseFloat(this.saleRate),
        profit: this.getProfit, // Need to modify
        amount: parseFloat(this.saleTotal),
        // category: this.productListProp[this.item.value].info.category
      }
    },
    correction() {
      this.confirmedData = null
      this.previewStatus = false;
    },

    confirm() {
      let finalData = this.confirmedData
      finalData.type = "stock"
      finalData.status= "out"
      this.previewStatus = false,
          this.weightedPurchaseRate = "",
          this.saleQuantity = "",
          this.saleRate = "0",
          this.saleTotal = "",
          this.profit = 0,
          this.previewStatus = false
      this.$emit('receiveSaleData', finalData);
      this.$swal('Success!!!', "তথ্য সফলভাবে যোগ হয়েছে", 'success');
      this.$bvModal.hide("modal-sale")
      this.previewStatus=false
      this.weightedPurchaseRate=""
      this.saleQuantity=""
      this.saleRate=""
      this.saleTotal=""
      this.profit= 0
      this.stockPurchaseStatus=null
      this.stockPurchaseWeightedTotalSumArray=[],
      this.confirmedData={}
      this.selectedProduct={}
      this.currentProduct=""
      this.stockArray = []
      this.purchaseRateCheckBox = false
      this.editablePurchaseRate = "ক্রয়মূল্য জানতে সঠিক পরিমান লিখুন"
      this.stockInfo = []
      this.stockLength = 0
    },

    stockPurchaseAndStatus: function () {
      this.stockPurchaseStatus = this.productListProp.map(
          function (v) {
            return v.stock.map(function (val) {
              let indvStock = {
                purchase_rate: val.purchase_rate,
                quantity: val.quantity,
                weighted_total: parseFloat(val.purchase_rate) * parseFloat(val.quantity)
              }
              return indvStock
            })
          }
      );
      return this.stockPurchaseStatus
    },
    getStockWeightedTotalSum() {
      this.stockPurchaseWeightedTotalSumArray = this.stockPurchaseStatus.map(function (v) {
        return {
          "weighted_total_sum": v.reduce((val, sum) => val + parseFloat(sum.weighted_total), 0),
          "quantity_sum": v.reduce((val, sum) => val + parseFloat(sum.quantity), 0),
          "weighted_avg_purchase_rate": parseFloat(parseFloat(v.reduce((val, sum) => val + parseFloat(sum.weighted_total), 0) / v.reduce((val, sum) => val + parseFloat(sum.quantity), 0)).toFixed(2))
        }
      })

      return this.stockPurchaseWeightedTotalSumArray
    },
    calculateProfit() {
      // console.log("sale rate: " + this.saleRate + " | sale quantity: " + this.saleQuantity + " weightedPurchaseRate: " + this.weightedPurchaseRate + " item.value: " + this.item.value)
      return (this.saleRate * this.saleQuantity) - (this.editablePurchaseRate * this.saleQuantity)
    },
    calculateProfitMargin() {
      return (((this.saleRate * this.saleQuantity) / (this.editablePurchaseRate * this.saleQuantity)) * 100) - 100
    },


    async getStockData(){
      this.$swal.showLoading();
      let url = "/api/stock/product/"+this.currentProduct
      await this.$http.get(url).then((response) => {
        this.$swal.close()
        this.stockInfo = response.data
        let newData = []
        for(let i = 0; i<this.stockInfo.price.length; i++){
          newData.push({
            price: this.stockInfo.price[i],
            qty: this.stockInfo.qty[i],

          })
        }
        this.stockInfo = newData
        // console.log("Hello-> This is the Data")
        // console.log(response.data)
        // const transformedData = {
        //   "priceQueue": [],
        //   "qtyQueue": []
        // };
        // transformedData.priceQueue.push(this.stockInfo.priceQueue)
        // transformedData.qtyQueue.push(this.stockInfo.qtyQueue)
        // this.editablePurchaseRate = this.stockInfo.priceQueue
        // this.stockInfo = transformedData
        // console.log("response")
        // console.log(typeof this.stockInfo.priceQueue)
        // this.stockLength = this.stockInfo.priceQueue.length
      }).catch((e)=>{
        this.$swal.close()
        this.$swal('দুঃখিত!!!', "এই প্রোডাক্টটি পাওয়া যায়নি! দয়া করে আবার চেষ্টা করুন..."+e, 'error');
      })
    },
    getWeightedPurchaseRateFIFO(){
      // console.log(this.stockInfo.qtyQueue.reduce((sum, x)=> sum+x,0))
      if(this.stockInfo.reduce((sum, x)=> sum+x.qty,0)<this.saleQuantity){
        this.$swal('সতর্ক বার্তা!!!', "স্টকের অতিরিক্ত পণ্য বিক্রয় সম্ভব নয়!", 'warning');
        this.saleQuantity = ""
      }
      let saleQuantityCopy = this.saleQuantity
      let qumulativeWeightedQtyPrice = 0;
      for(let i=0; i<this.stockInfo.length; i++){
        if(saleQuantityCopy>this.stockInfo[i].qty){
          // console.log(this.stockInfo.priceQueue[i]+" X "+this.stockInfo.qtyQueue[i]);
          qumulativeWeightedQtyPrice += this.stockInfo[i].price * this.stockInfo[i].qty;
          saleQuantityCopy -= this.stockInfo[i].qty;
        }else{
          // console.log(this.stockInfo.priceQueue[i]+" X "+saleQuantityCopy);
          qumulativeWeightedQtyPrice += this.stockInfo[i].price * saleQuantityCopy;
          break;
        }
      }
      console.log("Hey-> "+qumulativeWeightedQtyPrice+" ---> "+this.saleQuantity)
      console.log(this.stockInfo)
      let resultRate = (qumulativeWeightedQtyPrice / this.saleQuantity).toFixed(2)
      if(isNaN(resultRate)){
        this.editablePurchaseRate = "ক্রয়মূল্য জানতে সঠিক পরিমান লিখুন";
      }else{
        this.editablePurchaseRate = resultRate
      }
    }

  },
  watch: {

    async currentProduct(){

      this.saleQuantity=""
      this.saleRate=""
      this.saleTotal=""
      this.profit= 0   
      this.editablePurchaseRate = "ক্রয়মূল্য জানতে সঠিক পরিমান লিখুন"

      
      let singleProductArray = this.productListProp.filter((x)=>x.id===this.currentProduct)
      // console.log(singleProductArray.length)
      if(singleProductArray.length>0){
        this.selectedProduct = singleProductArray[0]
        await this.getStockData()
      }else{
        this.selectedProduct = {}
      }
    },

    saleQuantity: function (val) {
      if(isNaN(this.saleRate)){
        this.saleRate = 0.00
      }
      this.saleTotal = (val * this.saleRate).toFixed(2)
      this.getWeightedPurchaseRateFIFO();
    },
    saleTotal: function (val) {
      this.saleRate = (val / this.saleQuantity).toFixed(2)
    },
    item: function () {
      this.weightedPurchaseRate = this.stockPurchaseWeightedTotalSumArray[this.item.value].weighted_avg_purchase_rate
    }
  }
}
</script>

<style scoped>

</style>